import React from 'react'

import { useTranslation } from 'react-i18next'

import LoadingSpinner, { SpinnerSize } from '@components/shared/LoadingSpinner'

interface Props {
  message?: string
}

const LoadingMessage: React.FC<Props> = ({ message }) => {
  const { t } = useTranslation()
  return (
    <div className="absolute top-2 w-full flex flex-row justify-center z-20">
      <div className="shadow-lg rounded px-6 bg-white dark:bg-black-bg2 flex flex-row items-center">
        <LoadingSpinner size={SpinnerSize.SMALL} />
        <span className="ml-2">{message ?? t('messages.loading')}</span>
      </div>
    </div>
  )
}

export default LoadingMessage
